export default class VideoPlaylist {

    static initializeEvents() {
        this.transcriptionButtonEvents();
        this.switchVideoEvents();
        this.transcriptionAnchor();
    }

    static transcriptionButtonEvents() {
        Array
            .from(document.querySelectorAll('.video-playlist .video-playlist-transcription-button'))
            .forEach(button => button.addEventListener('click', event => {
                event.preventDefault();

                // Button to show or hide transcription
                const transcriptionElement = event.currentTarget.parentElement.querySelector('.video-playlist-item-current-transcription');
                transcriptionElement.parentElement.classList.toggle('hidden');
            }));
    }

    static switchVideoEvents() {
        Array
            .from(document.querySelectorAll('.video-playlist .video-playlist-item'))
            .forEach(videoPlaylistItem => videoPlaylistItem.addEventListener('click', event => {
                event.preventDefault();

                const currentItemElement = event.currentTarget;
                const parentItemElement = currentItemElement.closest('.selector-slick');
                const currentVideoElement = parentItemElement.previousElementSibling;

                if (!currentItemElement.classList.contains('active')) {
                    const src = currentItemElement.querySelector('input[name="video-playlist-item-src"]').value;
                    const copyright = currentItemElement.querySelector('input[name="video-playlist-item-copyright"]').value;
                    const transcription = currentItemElement.querySelector('input[name="video-playlist-item-transcription"]').value;

                    // Update current video
                    currentVideoElement.querySelector('.video-playlist-item-current-src iframe').src = src;
                    currentVideoElement.querySelector('.video-playlist-item-current-transcription').innerHTML = transcription.replace(/\n/gm, '<br>');

                    // Update active element
                    Array
                        .from(parentItemElement.parentElement.querySelectorAll('.video-playlist-item.active'))
                        .forEach(item => item.classList.remove('active'));

                    currentItemElement.classList.add('active');
                }
            }));
    }

    static transcriptionAnchor() {
        const anchor = window.location.hash;
        if (anchor && '#transcription_open' === anchor.trim()) {
            Array
                .from(document.querySelectorAll('.collapse-video-transcription'))
                .forEach(video =>  {
                    video.querySelector('.collapse-button').click()
                });
        }
    }

}